export enum PropertyCategory {
  Definitions,
  ErrorDescriptions,
  EventPayload,
  PathParameters,
  QueryParameters,
  RequestBody,
  ResponseFields,
}
